export const handlePropertyOptOut = async (addressLine1, city, state, zip, setSuccessMessage, setErrorMessage, clearMessages, brandId ) => {
  clearMessages();

  const res = await fetch(`/api/opt/property-opt-out`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ 
      brandId: brandId,
      addressLine1: addressLine1,
      city: city,
      state: state,
      zip: zip,
    }),
  });
  const { success } = await res.json();
  if (success) {
    setSuccessMessage("Opt out was successful!");
  } else {
    setErrorMessage("Opt out failed!");
  }
};

export const handlePeopleOptOut = async (reportToken, teaserName, age, teaserCity, brandId, toEmail, clearMessages, setErrorMessage, setSuccessMessage ) => {
  clearMessages();

  if(toEmail === "")
  {
    setErrorMessage("Please fill in an email to send the confirmation");
    return;
  }
  const res = await fetch(`/api/opt/opt-out`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ 
      ReportToken: reportToken,
      brandId: brandId,
      ToEmail: toEmail,
      firstName: teaserName.firstName,
      lastName: teaserName.lastName,
      age: age ? age : "N/A",
      location: teaserCity ? teaserCity.city + ", " + teaserCity.state : "N/A"  }),
  });
  const { success } = await res.json();
  if (success) {
    setSuccessMessage("Opt out was successful!");
  } else {
    setErrorMessage("Opt out failed!");
  }
};